export default "__VITE_ASSET__BgafyyrM__"